import store from '@/store'

const pending = (key: String, status: boolean) => {
  if (!key) return
  store.commit('pending', { key, status })
}

export const proxyActions = async (block: Function, key: string) => {
  try {
    pending(key, true)
    const result = await block()
    return result === undefined ? true : result
  } catch (error) {
    if (error.message !== 'cancel') {
      alert(error.message)
    }
    return false
  } finally {
    pending(key, false)
  }
}
